//logic to open and close the enquiry form modal   
document.addEventListener("DOMContentLoaded", (event) => {
  const openEnquiryBtn = document.getElementById('openConsultationPopup');
  
  //embedded form
  const overlayGroup = document.querySelector('.shopify-section-group-overlay-group');
  

  if (!openEnquiryBtn || !overlayGroup) {
    return;
  }
  
  
  //open the overlay when clicking the enquire button
  openEnquiryBtn.addEventListener('click', function(event){
    event.preventDefault();
    overlayGroup.style.display = 'block';
  })


  
  //add close button
  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.textContent = 'X';
  closeBtn.classList.add('close-btn');
  overlayGroup.appendChild(closeBtn);
  

  //close the overlay when clicking the close button
  const closeOverlay = function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    overlayGroup.style.display = 'none';
  };

  closeBtn.addEventListener('click', closeOverlay);
  closeBtn.addEventListener('touchend', closeOverlay, { passive: false });
  
});



  


  


